export default "__VITE_ASSET__CpMNEFe___"